import cn from 'classnames';
import type React from 'react';
import { Comment, ProgramPromo } from '@features/programs';
import { type Video } from '@shared/types/common';
import type { Program, RecommendationT } from '@shared/types/programs';
import { Card, Player } from '@shared/ui';
import type { PlayerVideoType } from '@shared/ui/iframes/common-player/ui.tsx';
import type { Mode } from 'library/types/programs';
import { ChooseDay, Text } from './frames';
import * as st from './Main.module.scss';

type Props = {
  mode: Mode;
  video: PlayerVideoType;
  // source: SourceType;
  // youtubeUrl: string;
  selectedDay: number;
  onDaySelect: (day: number) => void;
  description: string;
  about: string;
  // programId: number;
  changeMode: (mode: Mode) => void;
  program: Program;
  onRedirect?: () => void;
  isNeedPay: boolean;
  isThereOnlyOneVideoWithoutTrailerAndCoachComment?: boolean;
  currentActiveRecommendation?: RecommendationT;
  isCurrentVideoAvailableBySchedule?: boolean;
  onCurrentVideoNotAvailableClick?: () => void;
};

const Main: React.FC<Props> = ({
  mode,
  video,
  // source,
  // youtubeUrl,
  selectedDay,
  onDaySelect,
  description,
  about,
  program,
  changeMode,
  onRedirect,
  isNeedPay,
  isThereOnlyOneVideoWithoutTrailerAndCoachComment,
  currentActiveRecommendation,
  isCurrentVideoAvailableBySchedule,
  onCurrentVideoNotAvailableClick,
}) => {
  const periodicityDescription =
    'Программа построена по принципу 7-дневной периодичности. На каждый день назначен свой список видео.' +
    ' Выберите день, чтобы увидеть список, предназначенный для него.';
  return (
    <div
      className={cn(st.main, isThereOnlyOneVideoWithoutTrailerAndCoachComment && st.onlyOneVideo)}
    >
      <div className={st.main__player} id="video-anchor">
        <Card className={cn(st.main__wrapper, { [st.card]: mode === 'promo' || mode === 'video' })}>
          {mode === 'promo' && <ProgramPromo program={program} />}

          {mode === 'video' && (
            <Player
              video={video as Video}
              isNeedPay={isNeedPay}
              program={program}
              isCurrentVideoAvailableBySchedule={isCurrentVideoAvailableBySchedule}
              onCurrentVideoNotAvailableClick={onCurrentVideoNotAvailableClick}
            />
          )}

          {mode === 'days' && (
            <ChooseDay
              program={program}
              // programId={programId}
              selectedDay={selectedDay}
              onSelect={onDaySelect}
              changeMode={changeMode}
            />
          )}
          {mode === 'comment' && (
            <Comment currentActiveRecommendation={currentActiveRecommendation} />
          )}
        </Card>
        <div className={st.main__head}>
          {mode === 'comment' && (
            <div className={st.main__head__value}>Комментарий специалиста</div>
          )}

          {mode === 'video' && <div className={st.main__head__value}>{about}</div>}

          {mode === 'days' && <div className={st.main__head__value}>Выбор дня</div>}

          {mode === 'promo' && <div className={st.main__head__value}>Трейлер</div>}
        </div>
      </div>
      <div className={st.main__description}>
        {(mode === 'comment' || mode === 'video') && (
          <Text
            programId={program.pk}
            isNeedPay={isNeedPay}
            about={about}
            mode={mode}
            description={description}
            onRedirect={onRedirect}
            isCurrentVideoAvailableBySchedule={isCurrentVideoAvailableBySchedule}
            onCurrentVideoNotAvailableClick={onCurrentVideoNotAvailableClick}
          />
        )}
        {mode === 'days' && <section className={st.main__text}>{periodicityDescription}</section>}
      </div>
    </div>
  );
};

export default Main;
